'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactJplayerUtils = require('react-jplayer-utils');

var _actions = require('../../actions/actions');

var _next = require('./next');

var _next2 = _interopRequireDefault(_next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactJplayerUtils.connectWithId)(null, {
  next: _actions.next
})(_next2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplaylist/lib/components/next/nextContainer.js
// module id = 837
// module chunks = 0